__turbopack_context__.v({
  "img": "styles-module__I54zmq__img",
  "navigation": "styles-module__I54zmq__navigation",
});
